import { render, staticRenderFns } from "./test-portal-site-team.vue?vue&type=template&id=1926c097&"
import script from "./test-portal-site-team.vue?vue&type=script&lang=js&"
export * from "./test-portal-site-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-site-team.vue"
export default component.exports